<template>
  <div>
    <v-tabs v-if="lAction === 'view'" v-model="tab"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    @change="refreshDashboard(true)"
    >
    <v-tab href="#tab-0">
      {{ tabitems[0] + ' (' + visitorStatAtGate.waiting + ')' }}
    </v-tab>
    <v-tab href="#tab-1">
      {{ tabitems[1] + ' (' + visitorStatAtGate.inside + ')' }}
    </v-tab>
  </v-tabs>
  <v-container class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs-items v-if="lAction === 'view'" v-model="tab">
          <v-tab-item value="tab-0">
            <v-data-table
            :headers="visitHead"
            :items="waiting"
            hide-actions
            disable-initial-sort
            no-data-text="Nobody is waiting"
            >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="pl-2 text-xs-center"><v-icon>{{props.item.icon}}</v-icon></td>
                <td class="pa-0">{{props.item.visitor_name}}</td>
                <td class="pa-0">{{props.item.visiting}}</td>
                <td :class="'pa-0 text-xs-center subheading ' + (props.item.approval_status.includes('Approved') ? 'green' : props.item.approval_status.includes('Rejected') && !props.item.approval_status.includes('Notifying') && !props.item.approval_status.includes('Calling') ? 'red' : (props.item.approval_status.includes('Notifying') || props.item.approval_status.includes('Calling') || props.item.approval_status.includes('Push')) ? 'blue' : 'orange') + ' lighten-2'">
                  <span v-if="props.item.approval_status.includes('Approved') && props.item.approval_status.split(',').length > 1">Partly Approved</span>
                  <span v-else-if="props.item.approval_status.includes('Notifying') || props.item.approval_status.includes('Calling') || props.item.approval_status.includes('Push')">Pending</span>
                  <span v-else>{{props.item.approval_status}}</span>
                  <div>
                    <v-btn small outline @click="viewRecord(props.item, 'status')">View</v-btn>
                    <v-btn v-if="props.item.approval_status.includes('Approved')" small outline @click="sentInside(props.item)">Sent inside</v-btn>
                    <v-btn v-else-if="!props.item.approval_status.includes('Notifying') && !props.item.approval_status.includes('Calling')" small outline @click="clearVisitor(props.item)">Not Allowed</v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider></v-divider>
        </v-tab-item>

        <v-tab-item value="tab-1">
          <div class="grey lighten-4 pa-3">
            <v-flex xs12 sm6>
              <v-text-field
              append-icon="search"
              hide-details
              v-model="searchDash"
              class="pa-0 ml-1"
              placeholder="Search"
              clearable
              ></v-text-field>
            </v-flex>
          </div>
          <v-data-table
          :headers="$vuetify.breakpoint.smAndUp ? insideHeadSm : insideHead"
          :items="inside"
          hide-actions
          disable-initial-sort
          no-data-text="Nobody is inside"
          :search="searchDash"
          >
          <template slot="items" slot-scope="props">
            <tr @click="viewRecord(props.item)">
              <td class="pl-2 text-xs-center"><v-icon>{{props.item.icon}}</v-icon></td>
              <td class="pa-0">{{props.item.visitor_name}}</td>
              <td v-if="$vuetify.breakpoint.smAndUp" class="pa-0">{{props.item.visiting}}</td>
              <td class="pa-0">{{handy.formatDateTime(props.item.in_time)}}</td>
              <td class="pl-3 pr-1 text-xs-left subheading">
                <v-icon class="pr-1">{{ props.item.vehicle_type === 'Two Wheeler' ? 'directions_bike' : 'directions_car' }}</v-icon><b>{{props.item.vehicle_no ? props.item.vehicle_no.toUpperCase() : '-'}}</b>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-divider></v-divider>
      </v-tab-item>

      <div
      class="text-xs-center"
      style="position:fixed; bottom:15px; width:100%"
      >
      <v-btn
      @click.native="viewRegister">
      View Register
    </v-btn>
    <v-btn
    color="accent"
    @click.native="prepareEntry()">
    New Visitor Entry
  </v-btn>
</div>

</v-tabs-items>

<!-- 1. create / edit  entry -->
<v-container v-if="lAction === 'create'" class="pa-0" grid-list-md>
  <v-card flat>
    <v-flex xs12 mx-auto>
      <v-stepper v-model="entryStep" class="elevation-0">
        <!--<v-stepper-header class="elevation-0">
        <v-stepper-step :complete="entryStep > 1" step="1">Category</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="entryStep > 2" step="2">{{lVisitor.visitor_type === 'normal' ? 'Mobile' : (lVisitor.visitor_type === 'invite' ? 'OTP' : (lVisitor.visitor_type === 'staff' ? 'Attendance' : 'EasyPass')) }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="entryStep > 3" step="3" v-if="lVisitor.visitor_type === 'normal'">Visiting</v-stepper-step>
        <v-divider v-if="lVisitor.visitor_type === 'normal'"></v-divider>
        <v-stepper-step step="4">Summary</v-stepper-step>
      </v-stepper-header>-->

      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 sm7 md5 mx-auto>
              <div class="ma-2">
                <v-card class="mx-1 my-1">
                  <v-card-title class="title primary--text pb-1">
                    NORMAL VISITORS
                  </v-card-title>
                  <v-card-text class="py-0">
                    <v-list class="pa-0">
                      <template v-for="(normal, idx) in normalList">
                        <v-list-tile
                        :key="normal.visitor_cat"
                        avatar
                        @click="entryNext('normal', normal)"
                        >
                        <v-list-tile-avatar>
                          <v-icon large>{{normal.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="normal.visitor_cat"></v-list-tile-title>
                          <span v-if="normal.visitor_cat === 'Vendor'" class="caption">facility or household service provider</span>
                          <span v-if="normal.visitor_cat === 'Daily Helper'" class="caption">maid, drivers, etc with no easypass</span>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-if="idx < normalList.length - 1"></v-divider>
                    </template>
                  </v-list>
                </v-card-text>
              </v-card>
              <v-card class="mx-1 my-2">
                <v-card-title class="title primary--text">
                  PRE-APPROVED VISITORS
                </v-card-title>
                <v-card-text class="pt-0">
                  <v-list class="pa-0 white--text">
                    <template v-for="(spcl, idx) in spclList">
                      <v-list-tile
                      :key="spcl.visitor_cat"
                      avatar
                      @click="entryNext(spcl.visitor_type, spcl)"
                      :class="(idx === 0 ? 'green' : idx === 1 ? 'blue' : 'warning')"
                      >
                      <v-list-tile-avatar>
                        <v-icon v-if="spcl.visitor_cat.includes('Staff')" large class="white--text">{{spcl.icon}}</v-icon>
                        <v-icon v-else class="white--text">{{spcl.icon}}</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="spcl.visitor_cat"></v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-card-text>
            </v-card>
            <div class="text-xs-center mt-2">
              <v-btn @click="goHome"><v-icon>home</v-icon></v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-stepper-content>

    <v-stepper-content step="2" class="pa-0">
      <v-card flat>
        <v-card-title class="subheading primary lighten-2 white--text py-1">
          <v-icon class="px-2 white--text" x-large>{{ lVisitor.icon }}</v-icon>
          {{ lVisitor.visitor_cat && lVisitor.visitor_cat.toUpperCase() }}
        </v-card-title>
        <v-card-text class="pa-3">
          <v-layout row wrap>
            <v-flex xs12 sm7 md5 mx-auto>
              <v-form ref="form2">
                <v-layout row wrap v-if="lVisitor.visitor_type === 'normal'">
                  <v-flex xs12>
                    <v-layout row wrap class="text-xs-center">
                      <v-flex xs12>
                        <v-btn v-if="config.COMM_COUNTRY_CODE === 'MY' && config.COMM_ID === 337" @click="setNormalVisitMode('DL')" :class="'ma-0 mr-1 py-4 ' + (normalVisitMode === 'DL' ? 'warning black--text' : '')"><v-icon x-large>badge</v-icon></v-btn>
                        <v-btn @click="setNormalVisitMode('MN')" :class="'ma-0 py-4 ' + (normalVisitMode === 'MN' ? 'warning black--text' : '')"><v-icon x-large>contact_phone</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs12 class="mt-3 title">
                        <span v-if="this.normalVisitMode === 'DL'">Take Photo Of Driving License</span>
                        <span v-else-if="this.normalVisitMode === 'MN'">Enter Mobile Number</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="pb-0">
                    <vue-tel-input-vuetify
                    v-show="this.normalVisitMode === 'MN'"
                    class="title"
                    ref="refMob"
                    v-model="lVisitor.visitor_phone"
                    placeholder="Enter mobile number"
                    label=""
                    @keydown.native="ignoreBackspace"
                    @input="keepCursor"
                    :rules="[rules.required]"
                    :input-options="{showDialCode: true}"
                    @validate="validateMob"
                    :defaultCountry="config.COMM_COUNTRY_CODE"
                    />
                  </v-flex>
                  <v-flex xs12 class="pb-0" v-if="this.normalVisitMode === 'DL' && lVisitor.visitor_id">
                    <v-text-field
                    v-model.trim="lVisitor.visitor_id"
                    label="ID"
                    maxlength="25"
                    :rules="[rules.required]"
                    hide-details
                    class="title"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 v-if="this.normalVisitMode === 'DL' && !lVisitor.visitor_img_url" class="text-xs-center pa-0">

                    <v-card-text class="pb-0">
                      <v-layout row wrap>
                        <v-flex xs12 class="pa-0">
                          <div style="position: relative; width:100%; height:100%">
                            <div style="margin: auto; position:absolute; top:0; left:0; bottom:0; right:0; height:185px; width:285px; z-index: 1; border:3px solid yellow;border-radius: 20px;">
                              <div style="position:relative; top:32px; left:95px; height:50px; width:180px; z-index: 1; border:2px solid orange;">
                              </div>
                            </div>
                            <video id="cam" width="300px" height="auto" autoplay></video>
                          </div>
                        </v-flex>
                        <v-flex xs12>
                          <div class="pt-1">
                            <v-btn class="ma-0" icon @click="captureAndRecognizeOCR"><v-icon x-large>camera</v-icon></v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-flex>

                  <v-flex xs12 class="text-xs-center" v-if="lVisitor.visitor_phone || lVisitor.visitor_id">
                    <v-chip class="black--text success lighten-3" disabled v-if="lVisitor.found_in_db && (lVisitor.is_valid_number || lVisitor.visitor_id)">
                      <v-avatar class="success"><v-icon class="white--text">check</v-icon></v-avatar>
                      Known visitor
                    </v-chip>
                    <v-chip disabled class="error white--text" v-if="lVisitor.alreadyWaiting">
                      But, already waiting
                    </v-chip>
                    <v-chip disabled class="error white--text" v-else-if="lVisitor.alreadyInside">
                      But, already inside
                    </v-chip>
                    <v-chip class="black--text error lighten-3" disabled v-else-if="!lVisitor.found_in_db && (lVisitor.is_valid_number || lVisitor.visitor_id)">
                      <v-avatar class="error white--text"><v-icon class="white--text">clear</v-icon></v-avatar>
                      <span>No visitor history for given number</span>
                    </v-chip>
                  </v-flex>

                  <v-flex xs12 class="pb-0" v-if="lVisitor.is_valid_number || lVisitor.visitor_id">
                    <v-card>
                      <v-card-text class="px-4">
                        <v-layout row wrap>
                          <v-flex d-flex xs4 class="text-xs-center">
                            <div v-viewer="options" v-if="lVisitor.visitor_img_url">
                              <template>
                                <v-avatar size="100" class="grey lighten-4">
                                  <img :src="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : config.STATIC_FILES_DIR + lVisitor.visitor_img_url" :data-source="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : config.STATIC_FILES_DIR + lVisitor.visitor_img_url" style="cursor: pointer;">
                                </v-avatar>
                                <v-btn small icon class="ma-1"><v-icon @click="captureInDialog" small>photo_camera</v-icon></v-btn>
                              </template>
                            </div>
                            <v-avatar :size="100" class="grey lighten-4" v-else>
                              <v-icon @click="captureInDialog" size="50px">photo_camera</v-icon>
                            </v-avatar>
                          </v-flex>
                          <v-flex d-flex xs8 class="pl-3">
                            <v-layout row wrap>
                              <v-flex xs12 class="py-0">
                                <v-text-field
                                v-model.trim="lVisitor.visitor_name"
                                label="Name"
                                maxlength="25"
                                :rules="[rules.required]"
                                hide-details
                                class="title"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field
                                v-model.trim="lVisitor.no_of_persons"
                                label="No. of persons"
                                :rules="[rules.required]"
                                type="number"
                                hide-details
                                class="title"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs4 class="mt-0">
                            <v-select
                            v-model="lVisitor.vehicle_type"
                            label="Vehicle Type"
                            :items="vehicleTypes"
                            @input="$forceUpdate()"
                            :rules="[rules.required]"
                            hide-details
                            ></v-select>
                          </v-flex>
                          <v-flex xs8 class="pl-3 mt-0">
                            <v-text-field
                            v-model.trim="lVisitor.vehicle_no"
                            label="Vehicle No."
                            maxlength="15"
                            :rules="lVisitor.vehicle_type !== 'None' ? [rules.required] : []"
                            hide-details
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 v-if="lVisitor.visitor_cat === 'Delivery' || lVisitor.visitor_cat === 'Cab' || lVisitor.visitor_cat === 'Vendor'" class="text-xs-center mt-1">
                            <v-avatar size="50" tile @click="dlgOrg=true" v-if="lVisitor.org_img_url">
                              <img :src="config.STATIC_FILES_DIR + lVisitor.org_img_url">
                            </v-avatar>
                            <v-chip class="warning" v-else @click="dlgOrg=true">{{lVisitor.visitor_org || 'Choose ' + lVisitor.visitor_cat + ' Organization' }}</v-chip>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <!-- easypass, otp or staff -->
                <v-layout row wrap v-else class="text-xs-center">
                  <v-flex xs12 v-if="lVisitor.visitor_type === 'invite'">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-btn @click="setInviteMode('QR')" :class="'ma-0 mr-1 py-4 ' + (inviteMode === 'QR' ? 'warning black--text' : '')"><v-icon x-large>qr_code_2</v-icon></v-btn>
                        <v-btn @click="setInviteMode('OTP')" :class="'ma-0 py-4 ' + (inviteMode === 'OTP' ? 'warning black--text' : '')"><v-icon x-large>pin</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs12 class="mt-3 title">
                        <span v-if="this.inviteMode === 'QR'">Scan QR Code</span>
                        <span v-else-if="this.inviteMode === 'OTP'">Enter Invitation OTP</span>
                      </v-flex>
                      <v-flex xs12 v-if="this.inviteMode === 'QR'" class="pa-0">
                        <v-card-text style="width:100%; height:340px">
                          <qrcode-stream @decode="onQRCodeDecode"></qrcode-stream>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <v-text-field
                        ref="refInviteOtp"
                        v-model="lVisitor.invite_otp"
                        type="number"
                        label="Invitation OTP"
                        :rules="[rules.required]"
                        @input="loadInvite(lVisitor.invite_otp)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                        v-model="lVisitor.vehicle_type"
                        label="Vehicle Type"
                        :items="vehicleTypes"
                        hide-details
                        @input="$forceUpdate()"
                        :rules="[rules.required]"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                        v-model.trim="lVisitor.vehicle_no"
                        label="Vehicle Number"
                        maxlength="15"
                        hide-details
                        :rules="lVisitor.vehicle_type !== 'None' ? [rules.required] : []"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-else-if="lVisitor.visitor_type === 'easypass'">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-btn @click="setEasyPassMode('FR')" style="min-width:50px" :class="'ma-0 mr-1 py-4 ' + (easyPassMode === 'FR' ? 'warning black--text' : '')"><v-icon x-large>portrait</v-icon></v-btn>
                        <v-btn @click="setEasyPassMode('QR')" style="min-width:50px" :class="'ma-0 mr-1 py-4 ' + (easyPassMode === 'QR' ? 'warning black--text' : '')"><v-icon x-large>qr_code_2</v-icon></v-btn>
                        <v-btn @click="setEasyPassMode('EN')" style="min-width:50px" :class="'ma-0 mr-1 py-4 ' + (easyPassMode === 'EN' ? 'warning black--text' : '')"><v-icon x-large>pin</v-icon></v-btn>
                        <v-btn @click="setEasyPassMode('MN')" style="min-width:50px" :class="'ma-0 py-4 ' + (easyPassMode === 'MN' ? 'warning black--text' : '')"><v-icon x-large>contact_phone</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs12 class="mt-3 title">
                        <span v-if="this.easyPassMode === 'FR'">Take Photo Of Visitor</span>
                        <span v-else-if="this.easyPassMode === 'QR'">Scan QR Code</span>
                        <span v-else-if="this.easyPassMode === 'EN'">Enter EasyPass Number</span>
                        <span v-else-if="this.easyPassMode === 'MN'">Enter Mobile Number</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-show="this.easyPassMode === 'EN'"
                        ref="refEZNo"
                        v-model="lVisitor.easypass_no"
                        type="number"
                        placeholder="EasyPass number"
                        :rules="lVisitor.is_face_recog ? [] : [rules.required]"
                        @input="loadEasyPass(lVisitor.easypass_no, '', 'EN')"
                        ></v-text-field>

                        <vue-tel-input-vuetify
                        v-show="this.easyPassMode === 'MN'"
                        ref="refMob"
                        v-model="lVisitor.visitor_phone"
                        label=""
                        placeholder="Enter mobile number"
                        @keydown.native="ignoreBackspace"
                        @input="keepCursor"
                        :rules="[rules.required]"
                        :input-options="{showDialCode: true}"
                        @validate="validateEzMob"
                        :defaultCountry="config.COMM_COUNTRY_CODE"
                        />
                      </v-flex>
                      <v-flex xs12 v-if="this.easyPassMode === 'FR' || (lVisitor.visitor_img_url && !lVisitor.visitor_img_url.includes('base64'))" class="pa-0">
                        <v-layout row wrap>
                          <v-flex xs12 class="pa-0">
                            <v-card-text>
                              <div v-if="!lVisitor.visitor_img_url">
                                <video id="cam" width="195px" height="auto" autoplay></video>
                                <br/>
                                <div class="pt-1">
                                  <v-btn class="mb-0" icon @click="captureAndRecognize"><v-icon x-large>camera</v-icon></v-btn>
                                </div>
                              </div>
                              <div v-else class="white--text subheading">
                                <v-avatar tile size="255px">
                                  <img :src="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : config.STATIC_FILES_DIR + lVisitor.visitor_img_url">
                                </v-avatar>
                                <div class="mx-4">
                                  <div class="success px-2 py-1" v-if="lVisitor.is_face_recog">
                                    <strong>{{ lVisitor.visitor_name }}</strong>
                                    <div class="pb-1">{{ lVisitor.visitor_cat }}</div>
                                  </div>
                                  <div class="error px-2 py-3" v-else-if="lVisitor.face_recog_err">
                                    {{lVisitor.face_recog_err}}
                                  </div>
                                  <div class="info px-2 py-3" v-else>
                                    {{faceProgText}}
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-else-if="this.easyPassMode === 'QR'" class="pa-0">
                        <v-card-text style="width:100%; height:335px">
                          <qrcode-stream @decode="onQRCodeDecode"></qrcode-stream>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                        v-model="lVisitor.vehicle_type"
                        label="Vehicle Type"
                        :items="vehicleTypes"
                        hide-details
                        @input="$forceUpdate()"
                        :rules="[rules.required]"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                        v-model.trim="lVisitor.vehicle_no"
                        label="Vehicle Number"
                        maxlength="15"
                        hide-details
                        :rules="lVisitor.vehicle_type !== 'None' ? [rules.required] : []"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="lVisitor.visitor_type === 'staff'">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-text>
                          <div v-if="!lVisitor.visitor_img_url">
                            <video id="cam" width="80%" height="auto" autoplay></video>
                            <br/>
                            <div class="pt-1">
                              <v-btn icon @click="captureAndRecognize"><v-icon x-large>camera</v-icon></v-btn>
                            </div>
                          </div>
                          <div v-else class="white--text">
                            <v-avatar tile size="89%">
                              <img :src="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : config.STATIC_FILES_DIR + lVisitor.visitor_img_url">
                            </v-avatar>
                            <div class="mx-4">
                              <div class="success px-2 py-1" v-if="lVisitor.is_face_recog">
                                <strong>{{ lVisitor.visitor_name }}</strong>
                                <div class="pb-1">{{ lVisitor.visitor_cat }}</div>
                                <div v-if="lVisitor.log_action" class="display-1 py-2">{{lVisitor.log_action}}</div>
                              </div>
                              <div class="error px-2 py-3" v-else-if="lVisitor.face_recog_err">
                                {{lVisitor.face_recog_err}}
                              </div>
                              <div class="info px-2 py-3" v-else>
                                {{faceProgText}}
                              </div>
                            </div>
                          </div>
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12>
                    <v-chip class="black--text success lighten-3 mt-3" disabled v-if="lVisitor.visitor_type === 'invite' && lVisitor.is_valid_number && lVisitor.is_invite_recog">
                      <v-avatar class="success"><v-icon class="white--text">check</v-icon></v-avatar>
                      Valid OTP
                    </v-chip>
                    <v-chip disabled class="error white--text mt-3" v-if="lVisitor.alreadyWaiting">
                      Already waiting
                    </v-chip>
                    <v-chip disabled class="error white--text mt-3" v-else-if="lVisitor.alreadyInside">
                      Already inside
                    </v-chip>
                    <v-chip class="black--text error lighten-3 mt-3" disabled v-else-if="(lVisitor.easypass_err || lVisitor.invite_err) && lVisitor.is_valid_number">
                      <v-avatar class="error white--text"><v-icon class="white--text">clear</v-icon></v-avatar>
                      <span>{{lVisitor.easypass_err || lVisitor.invite_err}}</span>
                    </v-chip>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <div class="text-xs-center mt-2">
        <v-btn class="mr-1 ml-1" @click="entryBack"><v-icon>arrow_back</v-icon></v-btn>
        <v-btn class="mr-1 ml-1" @click="goHome"><v-icon>home</v-icon></v-btn>
        <v-btn v-if="lVisitor.visitor_type !== 'staff'" :disabled="(!lVisitor.is_valid_number && !lVisitor.visitor_id) || lVisitor.alreadyWaiting || lVisitor.alreadyInside || (lVisitor.visitor_type === 'easypass' && (lVisitor.easypass_err !== '' || (!lVisitor.is_face_recog && !lVisitor.is_easypass_recog))) || (lVisitor.visitor_type === 'invite' && !lVisitor.is_invite_recog)" class="ml-1 accent" @click="entryNext()">Next</v-btn>
        <v-btn v-else :disabled="!lVisitor.is_face_recog" class="ml-1 accent" @click="entryNext()">Next Staff</v-btn>
      </div>
    </v-stepper-content>

    <v-stepper-content step="3" class="pa-0">
      <v-card flat>
        <v-card-title class="subheading primary lighten-1 white--text py-1">
          <v-icon class="px-2 white--text" x-large>{{ lVisitor.icon }}</v-icon>
          {{ lVisitor.visitor_cat && lVisitor.visitor_cat.toUpperCase() }}
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm7 md5 mx-auto>
            <v-card-text class="pa-3">
              <v-layout row wrap>
                <v-flex xs12 class="title primary--text py-0">
                  <v-card-title class="pa-0">
                    <span class="mb-1">VISITING AREA</span>
                    <span><v-btn icon small @click="dlgSearchUnit=true; search=''"><v-icon>search</v-icon></v-btn></span>
                    <v-spacer></v-spacer>
                    <v-chip small v-if="choosenBlock" class="yellow my-0">{{choosenBlock + ' ' + choosenUnit}}</v-chip>
                  </v-card-title>
                </v-flex>
                <v-flex xs12 class="text-xs-center subheading pt-0 grey--text">
                  <span><i>{{choosenBlock ? 'Choose the house' : config.COMM_COUNTRY_CODE === 'MY' ? 'Choose the jalan' : 'Choose the block'}}</i></span>
                </v-flex>
                <v-flex xs12>
                  <v-layout style="height: 280px">
                    <v-flex xs12 style="overflow: auto">
                      <!-- here -->
                      <!-- blocks -->
                      <div v-if="!choosenBlock">
                        <v-layout row wrap v-if="blocks.length <= 10">
                          <v-flex xs6 v-for="(block, b) in blocks" :key="b">
                            <v-btn style="width:100%;" class="py-2 title ma-0" @click="chooseBlock('R', block)">{{block.block_nm}}</v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn style="width:100%" class="py-2 title ma-0" @click="chooseBlock('C')">COMMON AREA</v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-else>
                          <v-flex xs3 v-for="(block, b) in blocks" :key="b">
                            <v-btn style="width:100%;" class="py-2 title ma-0" @click="chooseBlock('R', block)">{{block.block_nm}}</v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn style="width:100%" class="py-2 title ma-0" @click="chooseBlock('C')">COMMON AREA</v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                      <!-- units -->
                      <div v-else>
                        <v-layout row wrap>
                          <v-flex xs3 v-for="(unit, u) in units" :key="u">
                            <v-btn class="py-2 title ma-0" @click="chooseUnit(unit)">{{unit.unit_no}}</v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="title primary--text mt-2 mb-1">
                  <span>{{'CHOOSEN HOUSES (' + lVisitor.unit.filter(rec => rec.selected !== false).length + ')'}}</span>
                </v-flex>
                <v-flex class="text-xs-center">
                  <v-layout style="height: 110px">
                    <v-flex xs12 style="overflow: auto">
                      <v-layout row wrap>
                        <div v-for="(unit, u) in lVisitor.unit.filter(rec => rec.selected !== false)" :key="u">
                          <v-chip class="info white--text title ma-1" v-model="unit.selected" close>{{unit.block_and_unit}}</v-chip>
                        </div>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>

      <div class="text-xs-center mt-2">
        <v-btn class="mr-1 ml-1" @click="entryBack"><v-icon>arrow_back</v-icon></v-btn>
        <v-btn class="ml-1 ml-1" @click="goHome"><v-icon>home</v-icon></v-btn>
        <v-btn class="ml-1 ml-1 accent" @click="entryNext()">Next</v-btn>
      </div>
    </v-stepper-content>

    <v-stepper-content step="4" class="pa-0">
      <v-card flat>
        <v-card-title class="subheading primary lighten-1 white--text py-1">
          <v-icon class="px-2 white--text" x-large>{{ lVisitor.icon }}</v-icon>
          {{ lVisitor.visitor_cat && lVisitor.visitor_cat.toUpperCase() }}
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm7 md5 mx-auto>
            <v-card-text class="pa-3 title">
              <v-layout row wrap>
                <v-flex d-flex xs4>
                  <div v-viewer="options" class="clearfix" v-if="lVisitor.visitor_img_url">
                    <template>
                      <v-avatar size="100" class="grey lighten-4">
                        <img :src="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : config.STATIC_FILES_DIR + lVisitor.visitor_img_url" :data-source="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : config.STATIC_FILES_DIR + lVisitor.visitor_img_url" style="cursor: pointer;">
                      </v-avatar>
                    </template>
                  </div>
                  <v-avatar size="100" class="grey lighten-4" v-else>
                    <v-icon color="grey" size="90px">person</v-icon>
                  </v-avatar>
                </v-flex>
                <v-flex d-flex xs8>
                  <v-layout row wrap>
                    <v-flex xs12 class="display-1">
                      {{lVisitor.visitor_name}}
                      <v-chip outline class="black--text subheading mt-0" disabled v-if="lVisitor.no_of_persons > 1">+ {{lVisitor.no_of_persons-1}}</v-chip>
                    </v-flex>
                    <v-flex xs12>
                      <v-icon medium>{{ lVisitor.vehicle_type === 'Two Wheeler' ? 'directions_bike' : 'directions_car' }}</v-icon>
                      {{lVisitor.vehicle_no && lVisitor.vehicle_no.toUpperCase() || 'NA'}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="mt-3 primary--text text-xs-center">
                  VISITING
                </v-flex>
                <v-flex xs12 v-if="lVisitor.unit.length" class="text-xs-center">
                  <v-card flat v-for="(unit, i) in lVisitor.unit" class="mb-2" :key="i">
                    <div class="pa-2">
                      <v-divider></v-divider>
                    </div>
                    <v-chip @input="refreshChosenUnits" v-model="unit.selected" class="display-1 black--text white" :close="lVisitor.unit.length > 1">
                      {{ unit.block_and_unit }}
                    </v-chip>
                    <div class="caption" v-for="(cust, c) in unit.cust_name_list.split(',')" :key="c">
                      <span v-if="cust.includes('No contact available')" class="red--text">
                        <i>{{ cust }}</i>
                      </span>
                      <span v-else><i>{{ cust }}</i></span>
                    </div>
                    <div class="subheading" v-if="lVisitor.nobody_at_units.findIndex(rec => rec.unit_id === unit.unit_id) >= 0">
                      Manual Security Approval
                      <v-btn small class="ma-0" fab depressed :class="unit.is_man_appr ? 'success white--text' : 'grey lighten-1 white--text'" @click="toggleManAppr(unit)"><v-icon medium>check</v-icon></v-btn>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-else class="display-1 black--text text-xs-center">
                  <div>Common Area</div>
                  <div class="caption grey--text">{{ lVisitor.common.com_area_app_pair && lVisitor.common.com_area_app_pair.cust_name }}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
      <div class="text-xs-center mt-2">
        <v-btn class="mr-1 ml-1" @click="entryBack"><v-icon>arrow_back</v-icon></v-btn>
        <v-btn class="mr-1" @click="goHome"><v-icon>home</v-icon></v-btn>
        <v-btn :disabled="beingSaved || (lVisitor.nobody_at_units.length !== lVisitor.unit.filter(rec => rec.is_man_appr).length)" class="ml-1 accent" @click="submitEntry()">{{lVisitor.visitor_type === 'normal' ? 'Submit for approval' : 'Send Inside'}}</v-btn>
      </div>
    </v-stepper-content>
  </v-stepper-items>
</v-stepper>
</v-flex>
</v-card>
</v-container>

<v-container v-if="lAction === 'view-reg'" class="pa-0" grid-list-sm>
  <v-card flat>
    <v-card-text class="pa-1">
      <v-layout row wrap>
        <v-flex xs12>
          <v-tabs v-model="regTab">
            <v-tab v-for="(regitem, n) in regTabItems" :key="n" :href="`#tab-${n}`" @click="loadReg(regitem)">
              {{regitem}}
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex xs12 v-if="regTab === 'tab-3'">
          <v-layout row wrap class="ml-2">
            <v-flex xs5>
              <v-dialog ref="dlgPeriodFrom"
              persistent v-model="dlgPeriodFrom"
              lazy max-width="290px"
              :return-value.sync="periodFrom"
              >
              <v-text-field
              slot="activator" label="From"
              v-model="periodFrom" append-icon="event"
              readonly clearable hide-details
              ></v-text-field>
              <v-date-picker v-model="periodFrom" scrollable
              first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="dlgPeriodFrom = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.dlgPeriodFrom.save(periodFrom)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs5>
          <v-dialog ref="dlgPeriodTo"
          persistent v-model="dlgPeriodTo"
          lazy max-width="290px"
          :return-value.sync="periodTo"
          >
          <v-text-field
          slot="activator" label="To"
          v-model="periodTo" append-icon="event"
          readonly clearable hide-details
          ></v-text-field>
          <v-date-picker v-model="periodTo" scrollable
          first-day-of-week="1"
          >
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgPeriodTo = false">Cancel</v-btn>
          <v-btn flat color="accent" @click="$refs.dlgPeriodTo.save(periodTo)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs2>
      <v-btn
      icon
      class="accent"
      @click.native="loadReg()"
      >
      Go
    </v-btn>
  </v-flex>
</v-layout>
</v-flex>
<v-flex xs12 class="title info--text mt-3 text-xs-center">
  {{register.length}} records found
</v-flex>
<v-flex xs12>
  <div class="grey lighten-4 pa-3">
    <v-flex xs12 sm6 mx-auto>
      <v-text-field
      append-icon="search"
      hide-details
      v-model="searchDash"
      class="pa-0 ml-1"
      placeholder="Search"
      clearable
      ></v-text-field>
    </v-flex>
  </div>
  <v-data-table
  :headers="regHead"
  :items="register"
  hide-actions
  disable-initial-sort
  no-data-text="Register is empty for chosen period"
  :search="searchDash"
  >
  <template slot="items" slot-scope="props">
    <tr :class="props.item.visitor_status === 'Waiting' ? 'grey--text' : ''" @click="viewRecord(props.item)">
      <td class="pa-0 text-xs-center"><v-icon :class="props.item.visitor_status === 'Waiting' ? 'grey--text' : ''">{{props.item.icon}}</v-icon></td>
      <td class="pa-0">{{props.item.visitor_name}}</td>
      <td class="pa-0">{{props.item.visiting}}</td>
      <td class="pa-0 text-xs-center">{{props.item.in_time ? handy.getTime12Hrs(props.item.in_time) : props.item.visitor_status}}</td>
      <td class="pa-0 text-xs-center">{{props.item.out_time ? handy.getTime12Hrs(props.item.out_time) : '-'}}</td>
    </tr>
  </template>
</v-data-table>
</v-flex>
</v-layout>
</v-card-text>
<div
class="text-xs-center"
style="position:fixed; bottom:15px; width:100%"
>
<v-btn @click="goHome"><v-icon>home</v-icon></v-btn>
</div>
</v-card>
</v-container>

<v-dialog v-model="secPostDlg" max-width="310px" persistent>
  <v-card>
    <v-card-title class="title">
      Choose security post!
    </v-card-title>
    <v-card-text>
      <v-data-table
      :items="secPostList"
      disable-initial-sort
      hide-actions
      hide-headers
      >
      <template slot="items" slot-scope="props">
        <tr @click="chooseSecPost(props.item)">
          <td class="text-xs-center"><span class="title primary--text">{{ props.item.security_post }}</span></td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<v-dialog v-model="dlgPreCond" :max-width="$vuetify.breakpoint.smAndUp ? '300px' : '280px'" persistent>
  <v-card>
    <v-card-title class="title grey lighten-4">
      COVID-19 Check
    </v-card-title>
    <v-card-text class="subheading pt-2">
      <v-container grid-list-md class="px-1 py-0">
        <v-layout row wrap>
          <v-flex xs2 class="pl-0 pt-3">
            <v-icon x-large>masks</v-icon>
          </v-flex>
          <v-flex xs6 class="pt-4">
            <span><b>Wearing mask</b></span>
          </v-flex>
          <v-flex xs4 class="text-xs-center">
            <v-btn class="ma-0" fab depressed :class="lVisitor.is_visitor_mask_on ? 'success white--text' : 'grey lighten-1 white--text'" @click="lVisitor.is_visitor_mask_on = !lVisitor.is_visitor_mask_on"><v-icon large>check</v-icon></v-btn>
          </v-flex>
          <v-flex xs2 class="mt-2">
            <v-icon large class="mt-1">fa fa-thermometer-3</v-icon>
          </v-flex>
          <v-flex xs6 class="pt-4">
            <b>Temperature °{{config.COMM_COUNTRY_CODE === 'MY' ? 'C' : 'F'}}</b>
          </v-flex>
          <v-flex xs4>
            <v-text-field
            hide-details
            v-model="lVisitor.visitor_temp"
            hide-details
            type="number"
            box
            :class="'pa-0 title ' + (lVisitor.visitor_temp >= bodyTempStart && lVisitor.visitor_temp <= bodyTempEnd ? lVisitor.visitor_temp > bodyTempNormal ? 'red lighten-2 white--text' : 'success white--text' : '')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed @click="dlgPreCond=false, lVisitor.is_visitor_mask_on=false, lVisitor.visitor_temp=''">Cancel</v-btn>
      <v-btn depressed class="accent" :disabled="!lVisitor.is_visitor_mask_on || Number(lVisitor.visitor_temp) < bodyTempStart || Number(lVisitor.visitor_temp) > bodyTempEnd " @click="lVisitor.is_visitor_pre_cond_met=true, entryNext()">Continue</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="dlgCommApr" max-width="500px" persistent>
  <v-card>
    <v-card-title class="title pb-0">
      Choose approver
      <v-spacer></v-spacer>
      <v-btn icon @click="dlgCommApr=false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :items="approvers"
      disable-initial-sort
      hide-actions
      hide-headers
      >
      <template slot="items" slot-scope="props">
        <tr @click="chooseCommApr(props.item)">
          <td class="text-xs-center"><span>{{ props.item.cust_name }}</span></td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<v-dialog v-model="dlgOrg" max-width="500px" persistent>
  <v-card>
    <v-card-title class="title pb-0 pt-2">
      {{'Choose ' + lVisitor.visitor_cat + ' Org.'}}
      <v-spacer></v-spacer>
      <v-btn icon @click="dlgOrg=false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="px-3 py-2">
      <v-container fluid grid-list-sm class="pa-0">
        <v-layout row wrap>
          <v-flex xs8>
            <v-text-field
            append-icon="search"
            placeholder="Search"
            solo
            hide-details
            v-model="searchOrg"
            clearable
            @input = "filterOrgList()"
            ></v-text-field>
          </v-flex>

          <v-flex xs4>
            <v-btn @click="prepareNewOrg">Add new</v-btn>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <span class="subheading primary--text">Top Visits</span>
          </v-flex>
          <v-flex v-for="(org, t) in topVisitorOrgList" :key="t" xs3 sm2>
            <v-card flat class="warning" height="65px" @click="chooseVisitOrg(org)">
              <img v-if="org.org_img_url" :src="config.STATIC_FILES_DIR + org.org_img_url" class="image" width="100%" height="100%">
              <div v-else class="subheading py-2 text-xs-center">{{org.visitor_org}}</div>
            </v-card>
          </v-flex>
          <v-alert :value="!topVisitorOrgList.length" color="info">
            No data available
          </v-alert>
          <v-flex xs12 class="mt-1">
            <span class="subheading primary--text">{{searchOrg ? 'Search Result' : 'All'}}</span>
          </v-flex>
          <v-flex v-for="(org, o) in filteredOrgList" :key="topVisitorOrgList.length+o" xs3 sm2>
            <v-card flat class="warning" height="65px" @click="chooseVisitOrg(org)">
              <img v-if="org.org_img_url" :src="config.STATIC_FILES_DIR + org.org_img_url" class="image" width="100%" height="100%">
              <div v-else class="subheading py-2 text-xs-center">{{org.visitor_org}}</div>
            </v-card>
          </v-flex>
          <v-alert :value="!filteredOrgList.length" color="info">
            No data available
          </v-alert>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>

<v-dialog v-model="dlgNewOrg" max-width="310px" persistent>
  <v-card>
    <v-card-title class="title">
      Add Organization
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-text-field
      v-model.trim="tmpVisitorOrg"
      label="Organization name"
      maxlength="50"
      :rules="[rules.required]"
      hide-details
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="dlgNewOrg=false">Cancel</v-btn>
      <v-btn @click="addNewVisitorOrg">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="dlgSearchUnit" max-width="310px" persistent>
  <v-card>
    <v-card-title class="title pb-0 pt-2">
      Search a house
      <v-spacer></v-spacer>
      <v-btn icon @click.native="dlgSearchUnit=false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-text-field
      append-icon="search"
      placeholder="Search"
      solo
      hide-details
      v-model="search"
      clearable
      ></v-text-field>
      <v-layout class="mt-3" style="height: 500px">
        <v-flex xs12 style="overflow: auto">
          <v-data-table
          :headers="unitsHead"
          :items="masterUnits"
          hide-actions
          hide-headers
          :search="search"
          disable-initial-sort
          height="100px"
          >
          <template slot="items" slot-scope="props">
            <tr @click="chooseUnit(props.item)">
              <td class="subheading">
                <div>
                  {{ props.item.block_and_unit }}
                </div>
                <div class="caption info--text" v-for="(cust, c) in props.item.cust_name_list && props.item.cust_name_list.split(',')">
                  {{cust}}
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-card>
</v-dialog>

<v-dialog v-model="vdoDlg" max-width="310px">
  <v-card>
    <v-card-text>
      <video v-if="vdoDlg" id="cam" style="width:280px; height:210px" autoplay></video>
    </v-card-text>
    <div class="text-xs-center pb-3 pt-0">
      <v-btn icon @click="capturePhoto(), vdoDlg=false"><v-icon x-large>camera</v-icon></v-btn>
    </div>
    <div style="position:absolute; top:15px; right:10px">
      <v-btn small color="grey" icon @click.stop="stopCamera(), vdoDlg=false"><v-icon small>close</v-icon></v-btn>
    </div>
  </v-card>
</v-dialog>

<v-dialog v-model="viewDetDlg" max-width="310px">
  <v-card>
    <v-card-title class="title grey lighten-4 px-2 py-1">
      <v-icon class="mr-2" medium>{{lVisitor.icon}}</v-icon>
      {{ lVisitor.visitor_cat }}
      <v-chip small :class="(lVisitor.visitor_status === 'Waiting' ? 'info' : lVisitor.visitor_status === 'Inside' ? 'success' : lVisitor.visitor_status === 'Overstay' ? 'orange' : 'grey') + ' white--text'" disabled>{{lVisitor.visitor_status}}</v-chip>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="viewDetDlg=false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="text-xs-center subheading px-2 py-0">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="title">{{ lVisitor.visitor_name }}</span><br />
            <span v-if="lVisitor.visitor_type!=='normal' && lVisitor.visitor_phone">{{'*******' + lVisitor.visitor_phone.substring(lVisitor.visitor_phone.length - 3)}}</span>
            <span v-else><a :href="'tel:' + lVisitor.visitor_phone">{{lVisitor.visitor_phone}}</a></span>
          </v-flex>
          <v-flex xs12>
            <div v-viewer="options" class="clearfix" v-if="lVisitor.visitor_img_url">
              <template>
                <v-avatar size="100" class="grey lighten-4">
                  <img :src="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : (config.STATIC_FILES_DIR + lVisitor.visitor_img_url)" :data-source="lVisitor.visitor_img_url.includes('base64') ? lVisitor.visitor_img_url : (config.STATIC_FILES_DIR + lVisitor.visitor_img_url)" style="cursor: pointer;">
                </v-avatar>
              </template>
            </div>
            <v-avatar size="100" class="grey lighten-4" v-else>
              <v-icon color="grey" size="90px">person</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex xs12>
            Visiting
          </v-flex>
          <v-flex xs12 class="title mb-2" v-if="lVisitor.visiting">
            <div v-for="flat in lVisitor.visiting.split(',')">
              {{flat}}
            </div>
            <div class="caption" v-if="lVisitor.visiting_area === 'C'">
              {{lVisitor.comm_area_app}}
            </div>
          </v-flex>
          <v-flex xs6>
            <b>IN:</b> {{ lVisitor.in_time ? handy.getTime12Hrs(lVisitor.in_time) : '-'}}
          </v-flex>
          <v-flex xs6>
            <b>OUT:</b> {{ lVisitor.out_time ? handy.getTime12Hrs(lVisitor.out_time) : "-"}}
          </v-flex>
          <v-flex xs12>
            <v-chip disabled class="primary warning--text title pa-2">
              <v-icon class="warning--text mr-2" large>{{ lVisitor.vehicle_type === 'Two Wheeler' ? 'directions_bike' : 'directions_car' }}</v-icon>
              <strong>{{lVisitor.vehicle_no && lVisitor.vehicle_no.toUpperCase() || 'NA'}}</strong>
            </v-chip>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-btn @click="checkOut()" v-if="lVisitor.visitor_status==='Inside'" class="accent">Check-out</v-btn>
            <v-btn @click="undoCheckOut()" v-else-if="lVisitor.visitor_status==='Left' && lVisitor.in_time">Undo Check-out</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>

<v-dialog v-model="viewStatusDlg" max-width="400px" persistent scrollable>
  <v-card v-if="viewStatusDlg">
    <v-card-title class="title grey lighten-4 px-2 py-1">
      <v-icon class="mr-2" medium>{{lVisitor.icon}}</v-icon>
      {{ lVisitor.visitor_cat + ' [' + lVisitor.visitor_name + ']'}}
      <v-spacer></v-spacer>
      <v-btn icon @click.native="closeStatusDlg"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="text-xs-center px-0 py-0">
      <v-container grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 class="subheading">
            Approval status
          </v-flex>
          <v-flex xs12 class="title">
            {{ lVisitor.approval_status.includes('Approved') && lVisitor.approval_status.split(',').length > 1 ? 'Partly Approved' : (lVisitor.approval_status.includes('Notifying') || lVisitor.approval_status.includes('Calling') || lVisitor.approval_status.includes('Push')) ? 'Pending' : lVisitor.approval_status }}
          </v-flex>
          <v-flex xs12 v-if="lVisitor.approval_status === 'Rejected'">
            {{ lVisitor.denied_due_to }}
          </v-flex>
          <v-flex xs12 class="mt-3">
            <v-expansion-panel
            popout
            v-model="lVisitor.last_chosen_panel"
            >
            <v-expansion-panel-content
            v-for="(det,i) in lVisitor.detail"
            :key="i"
            >
            <template v-slot:header>
              <v-layout row wrap class="py-2">
                <v-flex xs6 class="title pt-2">
                  <span v-if="lVisitor.whats_next[det.unit_id].is_ignored">
                    <strike>{{det.block_and_unit}}</strike>
                  </span>
                  <span v-else>
                    {{det.block_and_unit}}
                  </span>
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  <v-chip small disabled
                  :class="'ml-0 mr-2 mt-1 mb-1 black--text caption ' + ((det.approval_status_list.includes('Approved') ? 'green' : det.approval_status_list.includes('Rejected') && !det.approval_status_list.includes('Notifying') && !det.approval_status_list.includes('Calling') ? 'red' : (det.approval_status_list.includes('Notifying') || det.approval_status_list.includes('Calling') || det.approval_status_list.includes('Push')) ? 'blue' : 'orange') + ' lighten-2')"
                  >
                  {{ det.approval_status_list.includes('Approved') && det.approval_status_list.split(',').length > 1 ? 'Partly Approved' : (det.approval_status_list.includes('Notifying') || det.approval_status_list.includes('Calling') || det.approval_status_list.includes('Push')) ? 'Pending' : det.approval_status_list }}
                </v-chip>
              </v-flex>
            </v-layout>
          </template>
          <v-card>
            <v-card-text class="py-1">
              <v-layout row wrap v-for="(apr, a) in det.approvers" :key="a" class="py-1">
                <v-flex xs6 class="pt-2">
                  {{apr.cust_name}}
                </v-flex>
                <v-flex xs4 class="pt-2 text-xs-right">
                  <span :class="(apr.approval_status === 'Notifying' || apr.approval_status === 'Calling' ? 'blue' : apr.approval_status === 'Approved' ? 'green' : apr.approval_status === 'Rejected' ? 'red' : 'orange') + '--text'">{{apr.approval_status}}</span>
                </v-flex>
                <v-flex xs2>
                  <v-btn small fab depressed class="ma-0 grey lighten-4" v-if="apr.approval_status === 'No Response' || apr.approval_status === 'Not Reachable' || apr.approval_status === 'Rejected'"><a style="text-decoration: none;" :href="'tel:' + apr.contact_phone"><v-icon medium>phone</v-icon></a></v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card v-if="!(det.approval_status_list.includes('Notifying') || det.approval_status_list.includes('Calling') || det.approval_status_list.includes('Push') || det.approval_status_list === 'Approved')">
            <v-card-text class="pa-3">
              <v-layout row wrap>
                <v-flex xs12>
                  <strong>What's next?</strong>
                </v-flex>
                <v-flex xs10 class="pt-3">
                  Verified with {{lVisitor.visiting_area === 'R' ? 'resident' : 'approver'}} <span class="caption info--text" v-if="lVisitor.whats_next[det.unit_id].approval_mode">{{ ' [' + lVisitor.whats_next[det.unit_id].approval_mode + ']'}}</span>
                </v-flex>
                <v-flex xs2>
                  <v-btn small class="ma-0" fab depressed :class="lVisitor.whats_next[det.unit_id].is_man_verif ? 'success white--text' : 'grey lighten-1 white--text'" @click="toggleManVerif(lVisitor.whats_next[det.unit_id], 'is_man_verif')"><v-icon medium>check</v-icon></v-btn>
                </v-flex>
                <v-flex xs10 class="pt-3" v-if="lVisitor.visiting_area === 'R'">
                  Ignore this house for the current visit
                </v-flex>
                <v-flex xs2 v-if="lVisitor.visiting_area === 'R'">
                  <v-btn small class="ma-0" fab depressed :class="lVisitor.whats_next[det.unit_id].is_ignored ? 'success white--text' : 'grey lighten-1 white--text'" @click="toggleManVerif(lVisitor.whats_next[det.unit_id], 'is_ignored')"><v-icon medium>check</v-icon></v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-dialog v-model="dlgManVerif" max-width="310px" persistent>
              <v-card>
                <v-card-title class="title pb-0">
                  Verification mode
                  <v-spacer></v-spacer>
                  <v-btn icon @click="toggleManVerif(lVisitor.whats_next[det.unit_id], 'is_man_verif')"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                  :items="manAppModes"
                  disable-initial-sort
                  hide-actions
                  hide-headers
                  >
                  <template slot="items" slot-scope="props">
                    <tr @click="lVisitor.whats_next[det.unit_id].approval_mode = props.item; dlgManVerif=false">
                      <td class="text-xs-center"><span>{{ props.item }}</span></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</v-layout>
</v-container>
</v-card-text>
<v-card-actions class="pa-3 grey lighten-4" v-if="lVisitor.approval_status.includes('No Response') || lVisitor.approval_status.includes('Not Reachable')">
  <v-spacer></v-spacer>
  <v-btn @click="retryVisitor">Retry Notification</v-btn>
  <v-btn :disabled="lVisitor.whats_next && Object.values(lVisitor.whats_next).findIndex(rec => rec.is_man_verif) < 0 && Object.values(lVisitor.whats_next).findIndex(rec => rec.is_ignored) < 0" class="accent" @click="submitWhatsNext()">Submit Changes</v-btn>
</v-card-actions>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="4000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<!-- loading -->
<div v-if="load" style="position:absolute; top:50%; left:45%">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import { createWorker } from 'tesseract'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  components:
  {
    'v-download-as': VDownloadAs,
    'vue-tel-input-vuetify': VueTelInputVuetify,
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },
  data () {
    return {
      tempText: '',
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      search: '',
      load: false,
      searchDash: '',
      searchOrg: '',
      options: {
        toolbar: true,
        url: 'data-source'
      },
      // component specific
      timer: '',
      detTimer: '',
      tab: 'tab-0',
      tabitems: ['Waiting', 'Inside'],
      lVisitor: '',
      waiting: [],
      inside: [],
      register: [],
      entryStep: 1,
      topVisitorOrgList: [],
      visitorOrgList: [],
      filteredOrgList: [],
      vdoDlg: false,
      lastQRCodeReq: 'invite',
      normalList: [
        { visitor_cat: 'Guest', icon: 'face' },
        { visitor_cat: 'Delivery', icon: 'shopping_cart' },
        { visitor_cat: 'Cab', icon: 'directions_car' },
        { visitor_cat: 'Vendor', icon: 'card_travel' },
        { visitor_cat: 'Daily Helper', icon: 'people' }
      ],
      spclList: [
        { visitor_type: 'easypass', visitor_cat: 'EasyPass Visitor', icon: 'EZ' },
        { visitor_type: 'invite', visitor_cat: 'Invited Visitor', icon: 'OTP' },
        { visitor_type: 'staff', visitor_cat: 'Staff Attendance', icon: 'assignment_ind' }
      ],
      blocks: [],
      masterUnits: [],
      units: [],
      choosenBlock: '',
      choosenUnit: '',
      unitsHead: [
        { text: '', value: 'block_and_unit' }
      ],
      amHead: [
        { text: '', value: 'am_name' }
      ],
      visitHead: [
        { text: '', value: 'visitor_cat', class: 'pa-0', width: '30px', sortable: false },
        { text: 'Name', value: 'visitor_name', class: 'pa-0', width: '100px' },
        { text: 'Visiting', value: 'visiting', class: 'pa-0', width: '75px' },
        { text: 'Status', value: 'approval_status', class: 'pa-0 text-xs-center', width: '75px' }
      ],
      approvers: [],
      insideHeadSm: [
        { text: '', value: 'visitor_cat', class: 'pa-0', width: '30px', sortable: false },
        { text: 'Name', value: 'visitor_name', class: 'pa-0', width: '100px' },
        { text: 'Visiting', value: 'visiting', class: 'pa-0', width: '75px' },
        { text: 'Since', value: 'in_time', class: 'pa-0', width: '50px' },
        { text: 'Vehicle', value: 'vehicle_no', class: 'pa-0 text-xs-center', width: '150px' }
      ],
      insideHead: [
        { text: '', value: 'visitor_cat', class: 'pa-0', width: '30px', sortable: false },
        { text: 'Name', value: 'visitor_name', class: 'pa-0', width: '100px' },
        { text: 'Since', value: 'in_time', class: 'pa-0', width: '50px' },
        { text: 'Vehicle', value: 'vehicle_no', class: 'pa-0 text-xs-center', width: '150px' }
      ],
      regHead: [
        { text: '', value: 'visitor_cat', class: 'pa-0', width: '30px', sortable: false },
        { text: 'Name', value: 'visitor_name', class: 'pa-0', width: '100px' },
        { text: 'Visiting', value: 'visiting', class: 'pa-0', width: '75px' },
        { text: 'In', value: 'in_time', class: 'pa-0 text-xs-center', width: '50px' },
        { text: 'Out', value: 'out_time', class: 'pa-0 text-xs-center', width: '50px' }
      ],
      viewDetDlg: false,
      viewStatusDlg: false,
      appRetry: false,
      appManual: false,
      manAppModes: ['Intercom', 'Mobile Phone', 'Message', 'Escorted by resident', 'Escorted by security'],
      manAppMode: '',
      dlgManVerif: false,
      apprHead: [
        { text: 'Name', value: 'cust_name', class: 'pa-1' },
        { text: 'Phone', value: 'contact_phone', class: 'pa-1' },
        { text: 'Status', value: 'approval_status', class: 'pa-1' }
      ],
      regTabItems: ['today', 'yesterday', 'week', 'month/period'],
      periodFrom: '',
      periodTo: '',
      regTab: 'tab-0',
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      currentPeriod: 'today',
      vehicleTypes: ['Car', 'Two Wheeler', 'Mini Truck', 'Tanker', 'None', 'Others'],
      faceProgText: '',
      secPostList: [],
      secPostDlg: false,
      normalVisitMode: 'MN',
      easyPassMode: config.COMM_COUNTRY_CODE === 'MY' ? 'QR' : 'FR',
      inviteMode: config.COMM_COUNTRY_CODE === 'MY' ? 'QR' : 'OTP',
      isPreCondEnabled: config.IS_COVID_CHECK_ENABLED,
      dlgPreCond: false,
      bodyTempStart: config.COMM_COUNTRY_CODE === 'MY' ? 35 : 90,
      bodyTempNormal: config.COMM_COUNTRY_CODE === 'MY' ? 37 : 98.6,
      bodyTempEnd: config.COMM_COUNTRY_CODE === 'MY' ? 40 : 105,
      dlgCommApr: false,
      dlgOrg: false,
      visitorStatAtGate: {waiting: 0, inside: 0},
      ocrWorker: {},
      ocrRect: {left: 165, top: 175, width: 300, height: 130},
      dlgNewOrg: false,
      tmpVisitorOrg: '',
      dlgSearchUnit: false
    }
  },
  created () {
    this.refreshDashboard()
    this.loadBlocks()
    this.loadUnits()
    this.loadApprovers()
    this.setTimer()
    this.initOCR()
  },
  beforeDestroy () {
    this.stopCamera()
    this.clearTimer()
    this.clearDetTimer()
    this.ocrWorker.terminate()
  },
  mounted () {
    // load staff and shifts list
    this.lAction = 'view'
    // check if security location is chosen
    config.SECURITY_POST = localStorage.getItem('SECURITY_POST')
    if (!config.SECURITY_POST) {
      this.loadSecPosts()
      this.secPostDlg = true
    }
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    loading (status) {
      this.load = status
    },
    refreshDashboard (isTabChanged = false) {
      // 1. refresh stats if not being refreshed
      if (this.load) {
        return
      } else {
        // not busy
      }
      this.loadVisitorStatsAtGate()
      if (this.tab === 'tab-0') {
        this.loadWaiting()
      } else {
        this.loadInside(isTabChanged)
      }
    },
    setTimer () {
      // set timer to refresh waiting/inside/register tab for every two seconds
      this.timer = setInterval(this.refreshDashboard, 2000)
    },
    clearTimer () {
      clearInterval(this.timer)
    },
    setDetTimer () {
      // set timer to refresh a specific visit detail when dialog is open
      this.detTimer = setInterval(this.loadVisitDetail, 2000)
    },
    clearDetTimer () {
      clearInterval(this.detTimer)
    },
    getEmptyVisitor () {
      var emptyVisitor = {
        comm_id: config.COMM_ID,
        visiting_area: 'R',
        visitor_type: 'normal',
        visitor_sub_cat: '',
        visitor_org: '',
        visitor_name: '',
        visitor_phone: '',
        invite_otp: '',
        easypass_no: '',
        db: {},
        security_user_id: config.USER_ID,
        security_cust_id: config.CUST_ID,
        unit: [],
        common: {},
        alreadyWaiting: false,
        alreadyInside: false,
        log_mode: 'Security',
        log_location: config.SECURITY_POST,
        is_visitor_pre_cond_met: false,
        nobody_to_notify: false,
        nobody_at_units: [],
        country_code: config.COMM_COUNTRY_CODE,
        is_visitor_mask_on: false,
        visitor_temp: '',
        no_of_persons: '1'
      }
      return emptyVisitor
    },
    prepareEntry () {
      this.lVisitor = this.getEmptyVisitor()
      this.lAction = 'create'
      this.clearTimer()
    },
    prepareNewOrg () {
      this.tmpVisitorOrg = ''
      this.dlgNewOrg = true
    },
    addNewVisitorOrg () {
      if (this.tmpVisitorOrg) {
        this.lVisitor.visitor_org = this.tmpVisitorOrg
        this.dlgNewOrg = false
        this.dlgOrg = false
      } else {
        this.msg('Enter organization name', true)
      }
    },
    goHome () {
      // clear everything and go to security dashboard
      this.lVisitor = {}
      this.choosenBlock = ''
      this.choosenUnit = ''
      this.stopCamera()
      this.entryStep = 1
      this.lAction = 'view'
      this.setTimer()
    },
    entryBack () {
      if (this.entryStep === 2) {
        this.lVisitor = this.getEmptyVisitor()
        this.stopCamera()
      } else if (this.entryStep === 3) {
        this.lVisitor.unit = []
        this.lVisitor.common = {com_area_app_pair: ''}
        this.choosenBlock = ''
        this.choosenUnit = ''
      }
      if (this.entryStep === 4 && (this.lVisitor.visitor_type !== 'normal')) {
        this.entryStep -= 2
      } else {
        this.entryStep--
      }
    },
    entryNext (type = '', val = '') {
      if (this.entryStep === 1) {
        // prompts to ensure the precondition is met (mask and temp check for covid for example)
        if (type !== 'staff' && this.isPreCondEnabled) {
          if (!this.lVisitor.is_visitor_pre_cond_met) {
            this.lVisitor.visitor_type = type
            this.lVisitor.visitor_cat = val.visitor_cat
            this.lVisitor.icon = val.icon
            this.dlgPreCond = true
            return
          } else {
            this.dlgPreCond = false
          }
        } else {
          this.lVisitor.visitor_type = type
          this.lVisitor.visitor_cat = val.visitor_cat
          this.lVisitor.icon = val.icon
        }

        if (this.lVisitor.visitor_type === 'staff') {
          this.prepareCamera()
        } else {
          if (this.lVisitor.visitor_cat === 'Delivery' || this.lVisitor.visitor_cat === 'Daily Helper') {
            this.lVisitor.vehicle_type = 'Car'
          } else {
            this.lVisitor.vehicle_type = 'Car'
          }
          // load visitor org if required
          if (this.lVisitor.visitor_cat === 'Delivery' || this.lVisitor.visitor_cat === 'Cab' || this.lVisitor.visitor_cat === 'Vendor') {
            this.loadVisitorOrgList()
          }
        }
        this.entryStep++
        if (this.lVisitor.visitor_type === 'normal') {
          this.setNormalVisitMode()
        } else if (this.lVisitor.visitor_type === 'easypass') {
          this.setEasyPassMode()
        } else if (this.lVisitor.visitor_type === 'invite') {
          this.setInviteMode()
        }
        if (this.lVisitor.visitor_type === 'normal') {
          this.lVisitor.is_face_recog = true
          this.lVisitor.is_easypass_recog = true
          this.lVisitor.is_invite_recog = true
        }
      } else if (this.entryStep === 2) {
        if (this.$refs.form2.validate()) {
          // validate for valid image (not mandatory for invites)
          if (this.lVisitor.visitor_img_url || this.lVisitor.visitor_type === 'invite') {
            if (this.lVisitor.visitor_type !== 'normal') {
              if (this.lVisitor.visitor_type === 'invite') {
                // check there is someone to notify
                this.loadAvailableResToNotify()
                // go to last screen
                this.entryStep = 4
              } else if (this.lVisitor.visitor_type === 'easypass') {
                // check there is someone to notify
                this.loadAvailableResToNotify()
                // go to last screen
                this.entryStep = 4
              } else {
                // remain in same step and get ready for next staff attendance
                this.lVisitor.visitor_img_url = ''
                this.lVisitor.face_recog_err = ''
                this.lVisitor.is_face_recog = false
                this.$forceUpdate()
                this.prepareCamera()
              }
            } else {
              // validate for visitor org if required
              if (this.lVisitor.visitor_cat === 'Delivery' || this.lVisitor.visitor_cat === 'Cab' || this.lVisitor.visitor_cat === 'Vendor') {
                if (!this.lVisitor.visitor_org) {
                  this.msg('Choose visitor organization', true)
                  return
                }
              }
              // next step to ask whom he/she is visiting
              this.entryStep++
            }
          } else {
            this.msg('Take a photo of visitor', true)
          }
        }
      } else if (this.entryStep === 3) {
        this.lVisitor.unit = this.lVisitor.unit.filter(rec => rec.selected !== false)
        // check guard has chosen atleast one unit/common area to proceed further
        if (this.lVisitor.visiting_area === 'R' && !this.lVisitor.unit.length) {
          this.msg('Choose one or more units to be visited', true)
          return
        } else if (this.lVisitor.visiting_area === 'C') {
          if (!this.lVisitor.common.com_area_app_pair) {
            this.msg('Choose approver of common area visit', true)
            return
          }
        }
        // check there is someone to notify
        this.loadAvailableResToNotify()
        // last step
        // show summary so that guard can submit for approval
        this.entryStep = 4
      }
    },
    setNormalVisitMode (mode = this.normalVisitMode) {
      // clear the details if any
      this.lVisitor.visitor_phone = ''
      this.lVisitor.visitor_id = ''
      this.lVisitor.visitor_id_type = ''
      this.lVisitor.visitor_name = ''
      this.lVisitor.visitor_img_url = null
      this.lVisitor.visitor_sub_cat = ''
      this.lVisitor.visitor_org = ''
      this.lVisitor.org_img_url = ''
      this.lVisitor.vehicle_no = ''
      this.lVisitor.is_valid_number = false

      this.stopCamera()
      if (mode === 'DL') {
        this.lVisitor.visitor_id_type = mode
        // enable OCR
        this.prepareCamera()
      } else {
        setTimeout(() => {
          this.$refs.refMob.focus()
        }, 100)
      }
      this.normalVisitMode = mode
    },
    setEasyPassMode (mode = this.easyPassMode) {
      this.stopCamera()
      if (mode === 'FR') {
        this.prepareCamera()
      } else if (mode === 'QR') {
        this.lastQRCodeReq = 'easypass'
      } else if (mode === 'EN') {
        setTimeout(() => {
          this.$refs.refEZNo.focus()
        }, 100)
      } else {
        setTimeout(() => {
          this.$refs.refMob.focus()
        }, 100)
      }
      this.easyPassMode = mode
    },
    setInviteMode (mode = this.inviteMode) {
      this.stopCamera()
      if (mode === 'QR') {
        this.lastQRCodeReq = 'invite'
      } else {
        setTimeout(() => {
          this.$refs.refInviteOtp.focus()
        }, 100)
      }
      this.inviteMode = mode
    },
    submitEntry () {
      this.beingSaved = true
      // preprocessing
      this.lVisitor.comm_name = config.COMM_NAME // for notification

      this.lVisitor.unit_id_list = this.lVisitor.unit.map(rec => rec.unit_id)
      if (this.lVisitor.visitor_type === 'normal' && this.lVisitor.visiting_area === 'C') {
        this.lVisitor.common.approval_user_id = this.lVisitor.common.com_area_app_pair.user_id
        this.lVisitor.common.approval_cust_id = this.lVisitor.common.com_area_app_pair.cust_id
      }

      this.lVisitor.vehicle_type = this.lVisitor.vehicle_no ? this.lVisitor.vehicle_type : null
      this.lVisitor.is_pre_app = this.lVisitor.visitor_type === 'invite' || this.lVisitor.visitor_type === 'easypass'
      this.axios.post(config.API_URL + '/visitor/log', this.lVisitor)
      .then(response => {
        // refresh list in front end
        this.entryStep = 1
        this.tab = 'tab-0'
        this.lAction = 'view'
        this.beingSaved = false
        this.refreshDashboard()
        this.lVisitor = {}
        this.setTimer()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    prepareCamera () {
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome')
        return
      }
      // start camera and play
      this.chooseCamera()
    },
    chooseCamera () {
      navigator.mediaDevices.getUserMedia({video: {facingMode: 'environment'}})
      .then(stream => { // success
        document.querySelector('video').srcObject = stream
        this.localMediaStream = stream
      })
      .catch(error => {
        console.error('Webcam access is rejected: ' + error)
      })
    },
    capturePhoto () {
      const canvas = document.createElement('canvas')
      const video = document.querySelector('#cam')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      this.lVisitor.visitor_img_url = canvas.toDataURL('image/png')
      this.$forceUpdate()
      this.stopCamera()
    },
    stopCamera () {
      if (this.localMediaStream) {
        // stop the camera
        var tracks = this.localMediaStream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        this.localMediaStream.srcObject = null
      }
    },
    captureAndRecognize () {
      this.lVisitor.is_face_recog = false
      this.capturePhoto()
      // recognize the face
      var req = {
        comm_id: config.COMM_ID,
        user_id: config.USER_ID,
        face_img_data: this.lVisitor.visitor_img_url,
        source_type: this.lVisitor.visitor_type,
        log_mode: this.lVisitor.log_mode,
        log_location: this.lVisitor.log_location
      }
      this.faceProgText = 'Processing...'
      this.axios.post(config.API_URL + '/face-check/', req)
      .then(response => {
        if (response.data.length) {
          let faceRes = response.data[0]
          this.lVisitor.visitor_name = faceRes.visitor_name
          this.lVisitor.visitor_cat = faceRes.visitor_cat
          if (this.lVisitor.visitor_type === 'staff') {
            this.lVisitor.log_action = faceRes.log_action
          } else if (this.lVisitor.visitor_type === 'easypass') {
            this.lVisitor.easypass_id = faceRes.easypass_id
            // pull out easypass details
            this.loadEasyPass(faceRes.easypass_no, '', 'EN')
          }
          this.lVisitor.is_face_recog = true
        } else {
          this.lVisitor.face_recog_err = 'Not recognized'
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.lVisitor.face_recog_err = err.response.data
        this.$forceUpdate()
      })
    },
    captureInDialog () {
      this.prepareCamera()
      this.vdoDlg = true
    },
    async initOCR () {
      this.ocrWorker = createWorker()
      await this.ocrWorker.load()
      await this.ocrWorker.loadLanguage('eng')
      await this.ocrWorker.initialize('eng')
      await this.ocrWorker.setParameters({
        tessedit_char_whitelist: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ '
      })
    },
    async captureAndRecognizeOCR () {
      // 1. capture the photo of ID
      const canvas = document.createElement('canvas')
      const video = document.querySelector('#cam')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      this.lVisitor.visitor_img_url = canvas.toDataURL('image/png')
      this.$forceUpdate()
      this.stopCamera()

      // 2. OCR to recognize name and ID in the potential area of image
      this.loading(true)
      const { data: { text } } = await this.ocrWorker.recognize(this.lVisitor.visitor_img_url, { rectangle: this.ocrRect })
      this.loading(false)
      // alert(text)
      let textAry = text.split('\n')
      // 3. fetch the details from recognized text
      // 3.1 visitor name
      let nmIdx = -1
      for (let i = 1; i < textAry.length && nmIdx < 0; i++) {
        if (textAry[i - 1].includes('MALA')) {
          nmIdx = i
        }
      }
      this.lVisitor.visitor_name = nmIdx > 0 ? textAry[nmIdx] : textAry.length ? textAry[0] : ''
      this.lVisitor.visitor_name = this.lVisitor.visitor_name.substring(0, 25)
      // 3.2 visitor id
      let curLine = []
      let idIdx = -1
      for (let i = textAry.length - 1; i > nmIdx && idIdx < 0; i--) {
        curLine = textAry[i].split(' ')
        idIdx = curLine.findIndex(rec => rec.length >= 10)
      }
      if (idIdx >= 0) {
        this.lVisitor.visitor_id = curLine[idIdx]
      } else if (textAry.length > 2) {
        // find the possible id from last line
        curLine = textAry[textAry.length - 2]
        this.lVisitor.visitor_id = curLine.substring(curLine.indexOf(' '))
      }
      if (!this.lVisitor.visitor_id) {
        this.lVisitor.visitor_id = ''
        this.msg('Unable to recognize ID, please retry', true)
        this.lVisitor.visitor_img_url = ''
        this.prepareCamera()
        return
      }
      // 3. pull the visitor info
      this.getVisitorInfo()
    },
    chooseBlock (type, curBlock = {}) {
      if (type === 'R') {
        this.choosenBlock = curBlock.block_nm
        // filter units of this block
        this.units = this.masterUnits.filter(rec => rec.block_id === curBlock.block_id)
      } else {
        if (this.lVisitor.unit.length) {
          if (confirm('Sure, this will clear choosen houses?')) {
            this.lVisitor.unit = []
          } else {
            return
          }
        }
        // display dialog to choose common area approver
        this.dlgCommApr = true
      }
      this.lVisitor.visiting_area = type
    },
    chooseUnit (curUnit) {
      this.choosenUnit = curUnit.unit_no
      this.lVisitor.unit.push(Object.assign({}, curUnit)) // keep the original object safely before changes
      this.$forceUpdate()
      // clear temp variables after few secs
      setTimeout(() => {
        this.choosenBlock = ''
        this.choosenUnit = ''
      }, 500)
      this.dlgSearchUnit = false
    },

    chooseCommApr (curApr) {
      this.lVisitor.common.com_area_app_pair = curApr
      this.dlgCommApr = false
      this.entryNext()
    },
    sentInside (curVisit) {
      // update the status as the visitor is sent inside
      curVisit.security_user_id = config.USER_ID
      this.axios.post(config.API_URL + '/visitor/log-inside', curVisit)
      .then(response => {
        // update front end
        this.refreshDashboard()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    checkOut () {
      // update the status as the visitor is left the premises
      this.lVisitor.security_user_id = config.USER_ID
      this.axios.post(config.API_URL + '/visitor/log-checkout', this.lVisitor)
      .then(response => {
        // update front end
        this.refreshDashboard(true)
        // refresh reg if the action was done from reg page
        if (this.lAction === 'view-reg') {
          this.loadReg()
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
      this.viewDetDlg = false
    },
    undoCheckOut () {
      // update the status as the visitor is left the premises
      this.lVisitor.security_user_id = config.USER_ID
      this.axios.post(config.API_URL + '/visitor/log-undo-checkout', this.lVisitor)
      .then(response => {
        // update front end
        this.refreshDashboard
        // refresh reg if the action was done from reg page
        if (this.lAction === 'view-reg') {
          this.loadReg()
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
      this.viewDetDlg = false
    },
    viewRecord (curVisit, viewType = 'det') {
      this.lVisitor = Object.assign({}, curVisit)
      this.loadVisitDetail(true)
      if (viewType === 'det') { // show visitor detail
        this.viewDetDlg = true
      } else { // show status
        this.viewStatusDlg = true
        // start the timer to keep the status updated
        this.setDetTimer()
      }
    },
    closeStatusDlg () {
      this.viewStatusDlg = false
      this.clearDetTimer()
    },
    loadVisitDetail (resetWhatsNext = false) {
      // load approval details
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          visit_id: this.lVisitor.visit_id,
          visiting_area: this.lVisitor.visiting_area
        }
      }
      // visit detail
      this.axios.get(config.API_URL + '/getVisitDetByVisitId/', qry)
      .then(response => {
        this.lVisitor.detail = response.data
        if (resetWhatsNext) {
          // default temporary values
          this.lVisitor.last_chosen_panel = 0
          this.lVisitor.whats_next = []
          this.lVisitor.detail.forEach(det => {
            this.lVisitor.whats_next[det.unit_id] = {
              is_man_verif: false,
              is_ignored: false
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    retryVisitor () {
      this.lVisitor.security_user_id = config.USER_ID
      this.axios.post(config.API_URL + '/visitor/log-retry', this.lVisitor)
      .then(response => {
        this.msg('Retry request has been submitted')
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    submitWhatsNext () {
      // allow after manual verification
      this.axios.post(config.API_URL + '/visitor/log-whats-next', {visit_id: this.lVisitor.visit_id, unit_id_list: this.lVisitor.detail.map(rec => rec.unit_id), whats_next: this.lVisitor.whats_next, approval_user_id: config.USER_ID, approval_cust_id: config.CUST_ID, comm_id: config.COMM_ID})
      .then(response => {
        this.closeStatusDlg()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    toggleManVerif (det, action) {
      if (action === 'is_man_verif') {
        det.is_man_verif = !det.is_man_verif
        det.is_ignored = det.is_man_verif ? false : det.is_ignored
        this.dlgManVerif = det.is_man_verif
      } else {
        // not all units can be ignored
        if (Object.values(this.lVisitor.whats_next).filter(rec => rec.is_ignored).length < this.lVisitor.detail.length - 1) {
          det.is_ignored = !det.is_ignored
          det.is_man_verif = det.is_ignored ? false : det.is_man_verif
        } else {
          this.msg('You can not ignore all the houses. Instead, go back and tap on NOT ALLOWED if visitor not allowed to any house', true)
        }
      }
      if (!det.is_man_verif) {
        det.approval_mode = ''
      }
      this.$forceUpdate()
    },
    clearVisitor (curVisit) {
      if (confirm('Sure, visitor was not allowed?')) {
        // clear from waiting queue
        curVisit.security_user_id = config.USER_ID
        curVisit.visitor_status = 'Not Allowed'
        this.axios.post(config.API_URL + '/visitor/log-status', curVisit)
        .catch(err => {
          this.msg(err.response.data, true)
        })
      }
    },
    loadVisitorStatsAtGate () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getVisitorStatsAtGate/', qry)
      .then(response => {
        this.visitorStatAtGate = response.data
      })
    },
    loadWaiting () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      // list of people waiting
      this.axios.get(config.API_URL + '/getVisitorsWaiting/', qry)
      .then(response => {
        this.waiting = response.data
        // icons
        this.waiting.forEach(rec => {
          rec.icon = rec.visitor_type === 'normal' ? this.normalList.find(irec => irec.visitor_cat === rec.visitor_cat).icon : rec.visitor_type === 'easypass' ? 'EZ' : 'OTP'
          // update lVisitor if being viewed
          if (this.viewStatusDlg) {
            if (this.lVisitor.visit_id === rec.visit_id) {
              this.lVisitor.approval_status = rec.approval_status
            }
          }
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.waiting = []
      })
    },
    loadInside (isTabChanged = false) {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      // list of people waiting
      this.loading(isTabChanged)
      this.axios.get(config.API_URL + '/getVisitorsInside/', qry)
      .then(response => {
        this.inside = response.data
        // icons
        this.inside.forEach(rec => {
          rec.icon = rec.visitor_type === 'normal' ? this.normalList.find(irec => irec.visitor_cat === rec.visitor_cat).icon : rec.visitor_type === 'easypass' ? 'EZ' : 'OTP'
        })
        this.loading(false)
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.inside = []
        this.loading(false)
      })
    },
    viewRegister () {
      this.lAction = 'view-reg'
      this.loadReg()
      this.clearTimer()
    },
    loadReg (period = this.currentPeriod) {
      this.loading(true)
      // load visitor log for given period
      this.currentPeriod = period
      var curDate = new Date()
      if (period === 'today') {
        this.lCurrentFrom = curDate
        this.lCurrentTo = this.lCurrentFrom
      } else if (period === 'yesterday') {
        this.lCurrentFrom = curDate.setDate(curDate.getDate() - 1)
        this.lCurrentTo = this.lCurrentFrom
      } else if (period === 'week') {
        this.lCurrentFrom = curDate.setDate(curDate.getDate() - (curDate.getDay() + 6) % 7)
        this.lCurrentTo = new Date()
      } else if (period === 'month/period') {
        if (this.periodFrom && this.periodTo) {
          this.lCurrentFrom = this.periodFrom
          this.lCurrentTo = this.periodTo
        } else {
          this.lCurrentFrom = new Date(curDate.getFullYear(), curDate.getMonth(), 1)
          this.lCurrentTo = new Date()
          this.periodFrom = handy.formatDBDate(this.lCurrentFrom)
          this.periodTo = handy.formatDBDate(this.lCurrentTo)
        }
      }

      this.lCurrentFrom = handy.formatDBDate(this.lCurrentFrom)
      this.lCurrentTo = handy.formatDBDate(this.lCurrentTo)

      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          from_dt: this.lCurrentFrom,
          to_dt: this.lCurrentTo
        }
      }
      this.axios.get(config.API_URL + '/getVisitorForGivenPeriod/', qry)
      .then(response => {
        this.register = response.data
        // icons
        this.register.forEach(rec => {
          rec.icon = rec.visitor_type === 'normal' ? this.normalList.find(irec => irec.visitor_cat === rec.visitor_cat).icon : rec.visitor_type === 'easypass' ? 'EZ' : 'OTP'
        })
        this.loading(false)
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.register = []
        this.loading(false)
      })
    },
    ignoreBackspace (e) {
      if (e.key === 'Backspace') {
        const start = this.lVisitor.visitor_phone.length - 1
        this.lVisitor.visitor_phone = this.lVisitor.visitor_phone.substring(0, start)
        e.preventDefault()
      }
    },
    keepCursor () {
      this.$refs.refMob.cursorPosition = this.lVisitor.visitor_phone
    },
    validateMob ({ number, valid, country }) {
      this.lVisitor.is_valid_number = valid
      if (valid) {
        this.lVisitor.visitor_phone = number.e164
        // hide the keyboard
        this.hideKeyboard()
        // pull out previous history of normal visitor
        this.getVisitorInfo()
      } else {
        this.lVisitor.is_valid_number = false
        this.lVisitor.found_in_db = false
        this.lVisitor.alreadyWaiting = false
        this.lVisitor.alreadyInside = false
        this.lVisitor.visitor_img_url = null
      }
    },
    getVisitorInfo () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          visitor_phone: this.normalVisitMode === 'MN' ? this.lVisitor.visitor_phone : '',
          visitor_id: this.normalVisitMode === 'DL' ? this.lVisitor.visitor_id : '',
          visitor_id_type: this.lVisitor.visitor_id_type
        }
      }
      this.loading(true)
      this.axios.get(config.API_URL + '/getGlobalVisitorInfo/', qry)
      .then(response => {
        this.lVisitor.found_in_db = response.data.length > 0
        if (this.lVisitor.found_in_db) {
          this.lVisitor.alreadyWaiting = response.data[0].visitor_status === 'Waiting' && response.data[0].comm_id === config.COMM_ID
          this.lVisitor.alreadyInside = response.data[0].visitor_status === 'Inside' && response.data[0].comm_id === config.COMM_ID
          this.lVisitor.visitor_name = response.data[0].visitor_name
          this.lVisitor.visitor_img_url = response.data[0].visitor_img_url
          if (response.data[0].vehicle_type) {
            this.lVisitor.vehicle_type = response.data[0].vehicle_type
            this.lVisitor.vehicle_no = response.data[0].vehicle_no
          } else {
            this.lVisitor.vehicle_no = ''
          }
          // visitor entering with same category as he entered earlier
          if (this.lVisitor.visitor_cat === response.data[0].visitor_cat) {
            this.lVisitor.visitor_sub_cat = response.data[0].visitor_sub_cat
            this.lVisitor.visitor_org = response.data[0].visitor_org
            this.lVisitor.org_img_url = response.data[0].org_img_url
          } else {
            this.lVisitor.visitor_sub_cat = ''
            this.lVisitor.visitor_org = ''
            this.lVisitor.org_img_url = ''
          }
        } else {
          this.lVisitor.visitor_sub_cat = ''
          this.lVisitor.visitor_org = ''
          this.lVisitor.org_img_url = ''
          this.lVisitor.vehicle_no = ''
          if (this.normalVisitMode === 'MN') {
            this.lVisitor.visitor_name = ''
            this.lVisitor.visitor_img_url = null
          }
        }
        this.loading(false)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.loading(false)
      })
    },
    chooseVisitOrg (curOrg) {
      this.lVisitor.visitor_org = curOrg.visitor_org
      this.lVisitor.org_img_url = curOrg.org_img_url
      this.dlgOrg = false
    },
    loadVisitorOrgList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          visitor_cat: this.lVisitor.visitor_cat
        }
      }
      this.topVisitorOrgList = []
      this.visitorOrgList = []
      this.axios.get(config.API_URL + '/getTopVisitorOrgListByCommId/', qry)
      .then(response => {
        this.topVisitorOrgList = response.data
        this.axios.get(config.API_URL + '/getVisitorOrgListByCommLocale/', qry)
        .then(response => {
          this.visitorOrgList = response.data
          this.filteredOrgList = this.visitorOrgList
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    filterOrgList () {
      if (this.searchOrg) {
        this.filteredOrgList = this.visitorOrgList.filter(rec => rec.visitor_org.includes(this.searchOrg.toUpperCase()))
      } else {
        this.filteredOrgList = this.visitorOrgList
      }
    },
    loadUnits () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getUnitsAndResByCommId/', qry)
      .then(response => {
        this.masterUnits = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.units = []
      })
    },
    loadBlocks () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getBlocksByCommId/', qry)
      .then(response => {
        this.blocks = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.blocks = []
      })
    },
    loadApprovers () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getEligibleCommonAreaApprover/', qry)
      .then(response => {
        this.approvers = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.approvers = []
      })
    },
    hideKeyboard () {
      setTimeout(() => {
        // creating temp field
        var field = document.createElement('input')
        field.setAttribute('type', 'text')
        // hiding temp field from peoples eyes
        field.setAttribute('style', 'position:absolute; top: 0px; opacity: 0; -webkit-user-modify: read-write-plaintext-only; left:0px;')
        document.body.appendChild(field)

        // adding onfocus event handler for out temp field, which will gain focus for a moment and loose which makes the keyboard invisible
        field.onfocus = () => {
          setTimeout(() => {
            field.setAttribute('style', 'display:none;')
            setTimeout(() => {
              document.body.removeChild(field)
              document.body.focus()
            }, 14)
          }, 200)
        }
        // focusing it
        field.focus()
      }, 50)
    },
    validateEzMob ({ number, valid, country }) {
      if (valid) {
        this.lVisitor.visitor_phone = number.e164
        if (this.easyPassMode === 'MN') {
          this.lVisitor.is_valid_number = valid
          this.loadEasyPass('', number.e164, 'MN')
        }
      } else {
        this.lVisitor.alreadyWaiting = false
        this.lVisitor.alreadyInside = false
        this.lVisitor.visitor_img_url = null
        this.lVisitor.easypass_err = ''
      }
    },
    loadEasyPass (passNo, mobNo, mode) {
      if (mode === 'EN') {
        if (passNo.length !== 6) {
          this.lVisitor.alreadyWaiting = false
          this.lVisitor.alreadyInside = false
          this.lVisitor.visitor_img_url = null
          this.lVisitor.easypass_err = ''
          return
        } else {
          this.lVisitor.is_valid_number = true
        }
      } else {
        this.lVisitor.is_valid_number = true
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          easypass_no: passNo,
          visitor_phone: mobNo
        }
      }
      this.lVisitor.is_easypass_recog = false
      this.lVisitor.easypass_err = ''
      let apiName = mode === 'EN' ? '/getEasyPassByNo/' : '/getEasyPassByMobNo/'
      this.axios.get(config.API_URL + apiName, qry)
      .then(response => {
        if (response.data.length) {
          let validIdx = response.data.findIndex(rec => !rec.easypass_exp || (rec.easypass_exp && handy.formatDBDate(rec.easypass_exp) >= handy.formatDBDate(new Date())))
          let resPass = validIdx >= 0 ? response.data[validIdx] : response.data[0]
          // check validity
          if (resPass.easypass_exp && handy.formatDBDate(resPass.easypass_exp) < handy.formatDBDate(new Date())) {
            this.lVisitor.easypass_err = 'EasyPass Was Expired'
          } else if (resPass.easypass_status !== 'Active') {
            this.lVisitor.easypass_err = 'EasyPass Was ' + resPass.easypass_status
          } else {
            this.lVisitor.easypass_id = resPass.easypass_id
            this.lVisitor.visitor_name = resPass.visitor_name
            this.lVisitor.visitor_phone = resPass.visitor_phone
            this.lVisitor.visitor_cat = resPass.visitor_cat
            this.lVisitor.visitor_sub_cat = resPass.visitor_sub_cat
            this.lVisitor.visitor_org = resPass.visitor_org
            this.lVisitor.vehicle_type = resPass.vehicle_type || (this.lVisitor.visitor_cat === 'Daily Helper' ? 'None' : '')
            this.lVisitor.vehicle_no = resPass.vehicle_no || ''
            if (!this.lVisitor.visitor_img_url) { // show image from db if recognized by entering easypass number
              this.lVisitor.visitor_img_url = resPass.visitor_img_url
            }
            this.lVisitor.unit = []
            if (resPass.is_official) {
              this.lVisitor.visiting_area = 'C'
              this.lVisitor.common.approval_user_id = resPass.user_id
              this.lVisitor.common.approval_cust_id = resPass.cust_id
            } else if (resPass.unit_id_list) {
              this.lVisitor.visiting_area = 'R'
              resPass.unit_id_list.split(',').forEach(rec => {
                this.lVisitor.unit.push(Object.assign({}, this.masterUnits.find(unit => unit.unit_id === Number(rec))))
              })
            } else {
              // orphan EasyPass
              this.lVisitor.easypass_err = 'Not linked to any unit'
              return
            }
            this.lVisitor.is_easypass_recog = true
            this.lVisitor.is_face_recog = true
            this.stopCamera()
            // check for duplicate entries
            this.lVisitor.alreadyWaiting = this.waiting.findIndex(rec => (rec.visitor_phone === this.lVisitor.visitor_phone || rec.visitor_id === this.lVisitor.visitor_id)) >= 0
            this.lVisitor.alreadyInside = this.inside.findIndex(rec => (rec.visitor_phone === this.lVisitor.visitor_phone || rec.visitor_id === this.lVisitor.visitor_id)) >= 0
            this.$forceUpdate()
          }
        } else {
          this.lVisitor.easypass_err = 'Not found'
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadInvite (inviteOtp) {
      if (inviteOtp.length !== 6) {
        this.lVisitor.is_valid_number = false
        return
      } else {
        this.lVisitor.is_valid_number = true
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          invited_otp: inviteOtp
        }
      }
      this.lVisitor.is_invite_recog = false
      this.lVisitor.invite_err = ''
      this.axios.get(config.API_URL + '/getInviteByOTP/', qry)
      .then(response => {
        if (response.data.length) {
          let resInv = response.data[0]
          // check validity
          if (resInv.invite_status === 'Used') {
            this.lVisitor.invite_err = 'OTP was already used'
          } else if (handy.formatDBDate(resInv.otp_exp) < handy.formatDBDate(new Date())) {
            this.lVisitor.invite_err = 'OTP expired on ' + handy.formatDate(resInv.otp_exp)
          } else if (handy.formatDBDate(resInv.invited_dt) > handy.formatDBDate(new Date())) {
            this.lVisitor.invite_err = 'OTP valid only on ' + handy.formatDate(resInv.otp_exp)
          } else {
            this.lVisitor.invite_id = resInv.invite_id
            this.lVisitor.visitor_name = resInv.visitor_name
            this.lVisitor.visitor_phone = resInv.visitor_phone
            this.lVisitor.visitor_cat = resInv.visitor_cat
            this.lVisitor.vehicle_type = resInv.vehicle_type || ''
            this.lVisitor.vehicle_no = resInv.vehicle_no || ''
            this.lVisitor.unit = []
            if (resInv.is_official) {
              this.lVisitor.visiting_area = 'C'
              this.lVisitor.common.approval_user_id = resInv.user_id
              this.lVisitor.common.approval_cust_id = resInv.cust_id
            } else {
              this.lVisitor.visiting_area = 'R'
              this.lVisitor.unit = [this.masterUnits.find(unit => unit.unit_id === Number(resInv.unit_id))]
            }
            this.lVisitor.is_invite_recog = true
            // check for duplicate entries
            this.lVisitor.alreadyWaiting = this.waiting.findIndex(rec => rec.visitor_phone === this.lVisitor.visitor_phone) >= 0
            this.lVisitor.alreadyInside = this.inside.findIndex(rec => rec.visitor_phone === this.lVisitor.visitor_phone) >= 0
          }
        } else {
          this.lVisitor.invite_err = 'Not found'
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadSecPosts () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getSecurityPostsByCommId/', qry)
      .then(response => {
        this.secPostList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.secPostList = []
      })
    },
    chooseSecPost (curPost) {
      config.SECURITY_POST = curPost.security_post
      localStorage.setItem('SECURITY_POST', config.SECURITY_POST)
      this.secPostDlg = false
    },
    loadAvailableResToNotify () {
      if (this.lVisitor.unit.length) {
        var qry = {
          params: {
            comm_id: config.COMM_ID,
            user_id: config.USER_ID,
            unit_id_list: this.lVisitor.unit.map(rec => rec.unit_id)
          }
        }
        this.axios.get(config.API_URL + '/getAvailableResToNotify/', qry)
        .then(response => {
          if (response.data.length) {
            this.lVisitor.nobody_to_notify = false
            // any units not having proper contact to notify
            let availUnits = response.data.map(rec => rec.unit_id)
            this.lVisitor.nobody_at_units = this.lVisitor.unit.filter(rec => !availUnits.includes(rec.unit_id))
          } else {
            this.lVisitor.nobody_to_notify = true
            // all units being visited are not having proper contact to notify
            this.lVisitor.nobody_at_units = this.lVisitor.unit
          }
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.lVisitor.nobody_at_units = []
        })
      } else { // visiting common area
        this.lVisitor.nobody_to_notify = false
        this.lVisitor.nobody_at_units = []
      }
    },
    refreshChosenUnits () {
      this.lVisitor.unit = this.lVisitor.unit.filter(rec => rec.selected !== false)
      this.loadAvailableResToNotify()
    },
    toggleManAppr (curUnit) {
      curUnit.is_man_appr = !curUnit.is_man_appr
      this.$forceUpdate()
    },
    onQRCodeDecode (decodedString) {
      if (decodedString.length !== 6) {
        this.msg('Invalid QR code', true)
      } else {
        this.qrCodeDlg = false
        if (this.lastQRCodeReq === 'easypass') {
          this.lVisitor.easypass_no = decodedString
          this.loadEasyPass(this.lVisitor.easypass_no, '', 'EN')
        } else {
          this.lVisitor.invite_otp = decodedString
          this.loadInvite(this.lVisitor.invite_otp)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Visitors.vue?15570510